(function () {
  function showFeedback(wrap, message) {
    const fb = wrap.querySelector('[data-discount-feedback]');
    if (!fb) return;
    fb.textContent = message;
    fb.classList.remove('visually-hidden');
    window.clearTimeout(fb._hideT);
    fb._hideT = window.setTimeout(function () {
      fb.textContent = '';
      fb.classList.add('visually-hidden');
    }, 2200);
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-discount-banner__btn');
    if (!btn) return;
    const code = (btn.dataset.discountCode || '').trim();
    if (!code) return;
    const wrap = btn.closest('.product-discount-banner');
    if (!wrap) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(
        function () {
          showFeedback(wrap, 'Copied');
        },
        function () {
          showFeedback(wrap, 'Copy failed');
        }
      );
      return;
    }

    try {
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      showFeedback(wrap, ok ? 'Copied' : 'Copy failed');
    } catch (err) {
      showFeedback(wrap, 'Copy failed');
    }
  });
})();
